import { useState } from 'react'
import { Box, ButtonBase, Typography } from '@mui/material'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { postPrescFeedback } from '../../../../apis/reportPresc'
import { colorTokens } from '../../../../shared/styles/theme'
import { LAYOUT } from '../../../../shared/styles/spacing'
import { RADIUS } from '../../../../shared/styles/radii'
import { FeedbackDialog } from './FeedbackDialog'
import { Note } from './Note'

/**
 * 「ほか依頼」の最終行「改善依頼」(log/63 D3・D7)。FieldRow と同じ 3 列 (ラベル / 一言 /
 * 右端 gutter) で、gutter は ⚑ でなく吹き出し (色なし・状態なし・旗が無くても押せる)。
 * 押すと文章 1 欄の dialog。送れたら行に「改善依頼を送りました」(latest は toast を持たない)。
 *
 * 送るのは表示している版の id (D5)。状態は処方箋 1 枚ぶんなので、呼び出し側が key に
 * 処方箋の id を渡し、次の処方箋を開いたら作り直す (「送りました」も書きかけも持ち越さない)。
 */
export const FeedbackRow = ({ prescId }: { prescId: string }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isSent, setIsSent] = useState(false)

  const submit = async (note: string) => {
    await postPrescFeedback({ prescId, note })
    setIsSent(true)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        minHeight: LAYOUT.blockRowMinHeight,
        py: 0.25,
      }}
    >
      <Typography
        sx={{
          width: 116,
          flexShrink: 0,
          pt: '4px',
          fontSize: 12,
          color: colorTokens.fg.muted,
        }}
      >
        改善依頼
      </Typography>
      <Box
        sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}
      >
        {isSent && <Note>改善依頼を送りました</Note>}
      </Box>
      <ButtonBase
        onClick={() => setIsOpen(true)}
        aria-label="改善依頼を書く"
        sx={{
          width: 24,
          height: 24,
          flexShrink: 0,
          borderRadius: `${RADIUS.sm}px`,
          color: colorTokens.fg.disabled,
          '&:hover': { background: colorTokens.overlay.hover },
        }}
      >
        <ChatBubbleOutlineIcon sx={{ fontSize: 15 }} />
      </ButtonBase>
      <FeedbackDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={submit}
      />
    </Box>
  )
}
